import apiClient from '../apiClient';

// Invoices API calls

export const getInvoices = () => {
  return apiClient.get('/api/invoices');
};

